<script>
  import Embed from "./Embed.svelte";
  export let block;
</script>

<div class="flex flex-wrap justify-center bg-darkgray">
  {#each block.fields as field}
    <div class="w-full sm:w-1/3">
      <Embed block={{ primary: field }} portrait={true} />
    </div>
  {/each}
</div>
